import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ValidatorForm } from 'react-material-ui-form-validator';
import { Input, Button, Select, SuccessBlock, H2 } from 'components/Ui/index';
import { US_REGIONS } from 'utils/selectOptions';
import { updateBillingAddress as updateBillingAddressRequest } from 'containers/PrimoProfile/actions';
import { selectIsEditBillingSuccessful } from '../selectors';

import styles from './styles.scss';
import commonStyles from '../styles.scss';

const EditBillingAddressForm = ({
  onClose,
  updateBillingAddress,
  billingAccount,
  isEditBillingSuccessful,
}) => {
  const [values, changeValues] = useState(billingAccount);

  const handleChange = ({ target: { value, name } }) => {
    changeValues({ ...values, [name]: value });
  };

  const handleSubmit = () => {
    updateBillingAddress(values);
  };

  const clientLocation = 'US';
  const clientLocationLabel = clientLocation === 'US' ? 'State' : 'Province';
  const stateIsRequiredMessage = `${clientLocationLabel} is required`;

  const billingAccountAddress2 = billingAccount.address2
    ? billingAccount.address2
    : '';
  const valuesAddress2 = values.address2 ? values.address2 : '';
  const isSubmitDisabled =
    (billingAccount.address1 === values.address1 &&
      billingAccountAddress2 === valuesAddress2 &&
      billingAccount.city === values.city &&
      billingAccount.postalCode === values.postalCode) ||
    values.address1.length === 0 ||
    values.city.length === 0 ||
    values.postalCode.length === 0 ||
    !/^[0-9]{5}(?:-[0-9]{4})?$/.test(values.postalCode);

  return (
    <Fragment>
      {!isEditBillingSuccessful ? (
        <ValidatorForm onSubmit={handleSubmit}>
          <H2 className={commonStyles.header}>Edit billing address</H2>
          <div className={styles.inputFields}>
            <Input
              label="Street Address:"
              name="address1"
              id="address1"
              ariaLabel="Street address"
              smallLabel
              value={values.address1}
              onChange={handleChange}
              validators={['required']}
              errorMessages={['']}
            />
            <Input
              label="Apt/Ste/Other:"
              name="address2"
              id="address2"
              ariaLabel="Apartment suite other"
              smallLabel
              value={values.address2}
              onChange={handleChange}
            />
            <Input
              label="City:"
              name="city"
              id="city"
              ariaLabel="City"
              smallLabel
              value={values.city}
              onChange={handleChange}
              validators={['required']}
              errorMessages={['']}
            />
            <div className={commonStyles.inputBlock}>
              <Select
                label={clientLocationLabel}
                value={values.stateOrProvinceCode}
                items={US_REGIONS}
                onChange={handleChange}
                name="stateOrProvinceCode"
                icon="primaryArrow"
                smallLabel
                className={styles.stateSelect}
                validators={['required']}
                errorMessages={[stateIsRequiredMessage]}
                ariaLabel="State"
              />
              <Input
                label="ZIP code"
                name="postalCode"
                ariaLabel="ZIP code"
                smallLabel
                value={values.postalCode}
                onChange={handleChange}
                validators={['required', 'zip']}
                errorMessages={['', 'ZIP is not valid']}
              />
            </div>
          </div>
          <Fragment>
            <div className={styles.formBottom}>
              <Button
                className={commonStyles.cancelButton}
                text="Cancel"
                type="button"
                onClick={onClose}
              />
              <Button
                className={commonStyles.button}
                text="Save"
                type="button"
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
              />
            </div>
          </Fragment>
        </ValidatorForm>
      ) : (
        <div className={styles.successContainer}>
          <SuccessBlock text="Your changes have been saved." />
        </div>
      )}
    </Fragment>
  );
};

EditBillingAddressForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  updateBillingAddress: PropTypes.func.isRequired,
  isEditBillingSuccessful: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  isEditBillingSuccessful: selectIsEditBillingSuccessful(),
});

const mapDispatchToProps = {
  updateBillingAddress: updateBillingAddressRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditBillingAddressForm);
